import { object, string } from 'yup';

import { UserRewardType, VideoCategory } from 'v2/constants';
import { VideoForm } from 'v2/types/VideoModel';

export const initialValues: VideoForm = {
  name: '',
  category: VideoCategory.NEW,
  secondsToReward: 0,
  link: '',
  previewId: '',
  rewardType: UserRewardType.BALANCE,
  rewardValue: '',
};

export const validationSchema = object().shape({
  previewId: string().trim().required(),
});
